
import { IUsersRequest, State } from "@/utils/interfaces";
import { getUsers } from "@/services/user";

export const SET_USERS = "setUsers";

export default {
  namespaced: true,
  state: {
    users: []
  },
  getters: {
    users: ({ users }: State): any => users,
  },
  mutations: {
    [SET_USERS](state: State, payload: any): void {
      state.users = payload;
    },
  },
  actions: {
    setUsers: ({ commit }: any, users: any): void => {
      commit(SET_USERS, users);
    },
    async fetchUsers({ dispatch }: any, fields?: string[]): Promise<any> {
      const user: IUsersRequest | any = await getUsers(fields);
      dispatch("setUsers", user.data);
      return user.data;
    },
  },
}
